import { createBrowserRouter } from "react-router-dom";
import { TecnicoAziendale } from "../../pages/businessTechnician";
import { AddNewTech } from "../../pages/businessTechnician/addNew";
import { EditTech } from "../../pages/businessTechnician/edit";
import { CartellaAziendale } from "../../pages/cartellaAziendale";
import { Clienti } from "../../pages/clienti";
import { EditCustomer } from "../../pages/clienti/editCustomer";
import { NewCliente } from "../../pages/clienti/newCliente";
import { DashboardView } from "../../pages/dashboard";
import { GestioneAllegatiPartenza } from "../../pages/gestioneAllegati/departure";
import { GestioneAllegatiEntrata } from "../../pages/gestioneAllegati/entry";
import { PersonaleContabileView } from "../../pages/gestioneAmministrazione/personaleContabile";
import { ReportPersonaleContabileView } from "../../pages/gestioneAmministrazione/reportPersonaleContabile";
import { IncProformaDetails } from "../../pages/gestioneAmministrazione/reportPersonaleContabile/incDetails";
import { ComplianceRequests } from "../../pages/gestioneCertificazione/complianceRequests";
import { AddComplianceRequest } from "../../pages/gestioneCertificazione/complianceRequests/add";
import { EditRequestComplianceRequest } from "../../pages/gestioneCertificazione/complianceRequests/edit";
import { GestioneBiosuisse } from "../../pages/gestioneClienti/gestioneBiosuisse";
import { AddCertificazioneBiosuisse } from "../../pages/gestioneClienti/gestioneBiosuisse/addCertificazioneBiosuisse";
import { GestioneDemeter } from "../../pages/gestioneClienti/gestioneDemeter";
import { AddCertificazioneDemeter } from "../../pages/gestioneClienti/gestioneDemeter/addCertificazioneDemeter";
import { EditCertificazioneDemeter } from "../../pages/gestioneClienti/gestioneDemeter/editCertificazioneDemeter";
import { RegistriAziendali } from "../../pages/gestioneClienti/registriAziendali";
import { AddRegistroAziendale } from "../../pages/gestioneClienti/registriAziendali/add";
import { EditRegistroAziendale } from "../../pages/gestioneClienti/registriAziendali/edit";
import { ReportRegistriAziendali } from "../../pages/gestioneClienti/registriAziendali/report";
import { RID } from "../../pages/gestioneClienti/RID";
import { AddRID } from "../../pages/gestioneClienti/RID/addRID";
import { EditRID } from "../../pages/gestioneClienti/RID/editRID";
import { MonitoraggioRID } from "../../pages/gestioneClienti/RID/monitoraggioRid";
import { Liberatorie } from "../../pages/gestioneControllo/liberatorie";
import { M024 } from "../../pages/gestioneControllo/m024";
import { EditM024 } from "../../pages/gestioneControllo/m024/editM024";
import { PAC } from "../../pages/gestioneControllo/pac";
import { AddPAC } from "../../pages/gestioneControllo/pac/addPac";
import { EditPAC } from "../../pages/gestioneControllo/pac/editPac";
import { GestionePAC } from "../../pages/gestioneControllo/pac/gestionePAC";
import { GestionePACAdd } from "../../pages/gestioneControllo/pac/gestionePAC/addPac";
import { GestionePACEdit } from "../../pages/gestioneControllo/pac/gestionePAC/editPac";
import { PeriodoConversione } from "../../pages/gestioneControllo/periodoConversione";
import { PeriodoConversioneAdd } from "../../pages/gestioneControllo/periodoConversione/add";
import { PeriodoConversioneEdit } from "../../pages/gestioneControllo/periodoConversione/edit";
import { Segnalazioni } from "../../pages/gestioneControllo/segnalazioni";
import { AddReporting } from "../../pages/gestioneControllo/segnalazioni/addReporting";
import { EditReporting } from "../../pages/gestioneControllo/segnalazioni/editReporting";
import { GestioneDocumenti } from "../../pages/gestioneDocumenti";
import { GestionePersonale } from "../../pages/gestionePersonale";
import { EditTraining } from "../../pages/gestionePersonale/boxFormazione/editFormazione";
import { NewTraining } from "../../pages/gestionePersonale/boxFormazione/newFormazione";
import { EditStaff } from "../../pages/gestionePersonale/editStaff";
import { Formazione } from "../../pages/gestionePersonale/formazione";
import { NewStaff } from "../../pages/gestionePersonale/NewStaff";
import { GestionePrelieviForAll } from "../../pages/gestionePrelievi";
import { GestionePrelievi } from "../../pages/gestionePrelievi/adminIndex";
import { MeasureRecipient } from "../../pages/gestioneProvvedimenti/measureRecipients";
import { CustomerMeasueres } from "../../pages/gestioneProvvedimenti/measures";
import { AddNewCodexMeasureStep1 } from "../../pages/gestioneProvvedimenti/measures/addNew/Step1";
import { AddNewCodexMeasureStep2 } from "../../pages/gestioneProvvedimenti/measures/addNew/Step2";
import { EditCodexMeasure } from "../../pages/gestioneProvvedimenti/measures/edit";
import { AddNewCodexMeasureOtherOdc } from "../../pages/gestioneProvvedimenti/measuresOtherOdc/add";
import { EditCodexMeasureOtherOdc } from "../../pages/gestioneProvvedimenti/measuresOtherOdc/edit";
import { ReinforcedControlMeasure } from "../../pages/gestioneProvvedimenti/reinforcedControlMeasure";
import { AddReinforcedControlMeasure } from "../../pages/gestioneProvvedimenti/reinforcedControlMeasure/add";
import { EditReinforcedControlMeasure } from "../../pages/gestioneProvvedimenti/reinforcedControlMeasure/edit";
import { GestioneTipologiaRegistri } from "../../pages/gestioneTipologiaRegistri";
import { Incarichi } from "../../pages/incarichi";
import { AddAssignment } from "../../pages/incarichi/addAssignment";
import { EditAssignment } from "../../pages/incarichi/editAssignment";
import { InspectionVisitEdit } from "../../pages/incarichi/inspectionVisit/edit";
import { MonitoringFaseAvvio } from "../../pages/monitoraggi/monitoringFaseAvvio";
import { Notify } from "../../pages/notifiche";
import { NotificationAdminPanel } from "../../pages/notifiche/admin";
import { NotifyBioEdit } from "../../pages/notifiche/biologica/edit";
import { NotifyGlobalGapEdit } from "../../pages/notifiche/globalGap/edit";
import { OrganismiDiControllo } from "../../pages/odc";
import { PageNotFound } from "../../pages/pageNotFound";
import { DepartureProtocol } from "../../pages/protocol/departure";
import { AddDepartureProtocol } from "../../pages/protocol/departure/add";
import { EditDepartureProtocol } from "../../pages/protocol/departure/edit";
import { EntryProtocol } from "../../pages/protocol/entry";
import { AddEntryProtocol } from "../../pages/protocol/entry/add";
import { EditEntryProtocol } from "../../pages/protocol/entry/edit";
import { OldProtocol } from "../../pages/protocol/pre2015";
import { ReportProtocol } from "../../pages/protocol/report";
import { SchedaCalcoloAdmin } from "../../pages/schedaCalcolo/adminIndex";
import { SchedaCalcoloCustomer } from "../../pages/schedaCalcolo/customer";
import { SchedaCalcoloAdminEdit } from "../../pages/schedaCalcolo/edit/editAdminIndex";
import { SOTAdmin } from "../../pages/sot/adminPage";
import { Gestione } from "../../pages/tools/gestione";
import { EditUser } from "../../pages/users/edit-user";
import { User } from "../../pages/users/user";
import { Users } from "../../pages/users/users";
import { PcDetailsInc } from "../../pages/gestioneAmministrazione/personaleContabile/detailsInc";

const adminRouter = createBrowserRouter([
    {
        path: '/',
        element: (<DashboardView />),
    },
    {
        path: '/users',
        element: (<Users />)
    },
    {
        path: '/customers',
        element: (<Clienti />)
    },
    {
        path: '/customer',
        element: (<NewCliente />)
    },
    {
        path: '/tecnicoAziendale',
        element: (<AddNewTech />)
    },
    {
        path: '/editTecnicoAziendale/:id',
        element: (<EditTech />)
    },
    {
        path: '/tecnico-aziendale',
        element: (<TecnicoAziendale />)
    },
    {
        path: '/user',
        element: (<User />)
    },
    {
        path: '/edit-user/:id',
        element: (<EditUser />)
    },
    {
        path: '/edit-customer/:id',
        element: (<EditCustomer />)
    },
    {
        path: '/gestionePersonale',
        element: (<GestionePersonale />)
    },
    {
        path: '/formazione',
        element: (<Formazione />)
    },
    {
        path: '/nuovoFormazione',
        element: (<NewTraining />)
    },
    {
        path: '/editFormazione',
        element: (<EditTraining />)
    },
    {
        path: '/nuovoPersonale',
        element: (<NewStaff />)
    },
    {
        path: '/editPm/:id',
        element: (<EditStaff />)
    },
    {
        path: '/entryProtocol',
        element: (<EntryProtocol />)
    },
    {
        path: '/departureProtocol',
        element: (<DepartureProtocol />)
    },
    {
        path: '/reportProtocol',
        element: (<ReportProtocol />)
    },
    {
        path: '/addEntryProtocol',
        element: (<AddEntryProtocol />)
    },
    {
        path: '/editEntryProtocol',
        element: (<EditEntryProtocol />)
    },
    {
        path: '/addDepartureProtocol',
        element: (<AddDepartureProtocol />)
    },
    {
        path: '/editDepartureProtocol',
        element: (<EditDepartureProtocol />)
    },
    {
        path: '/gestioneDocumenti',
        element: (<GestioneDocumenti />)
    },
    {
        path: '*',
        element: (<PageNotFound />)
    },
    {
        path: '/gaEntrata',
        element: (<GestioneAllegatiEntrata />)
    },
    {
        path: '/gaPartenza',
        element: (<GestioneAllegatiPartenza />)
    },
    {
        path: '/cartellaAziendale',
        element: (<CartellaAziendale />)
    },
    {
        path: '/rid',
        element: (<RID />)
    },
    {
        path: '/addRid',
        element: (<AddRID />)
    },
    {
        path: '/editRid',
        element: (<EditRID />)
    },
    {
        path: '/segnalazioni',
        element: (<Segnalazioni />)
    },
    {
        path: '/addSegnalazione',
        element: (<AddReporting />)
    },
    {
        path: '/liberatorie',
        element: (<Liberatorie />)
    },
    {
        path: '/editSegnalazione',
        element: (<EditReporting />)
    },
    {
        path: '/registriAziendali',
        element: (<RegistriAziendali />)
    },
    {
        path: '/addRegistroAziendale',
        element: (<AddRegistroAziendale />)
    },
    {
        path: '/editRegistroAziendale',
        element: (<EditRegistroAziendale />)
    },
    {
        path: '/reportRegistroAziendale',
        element: (<ReportRegistriAziendali />)
    },
    {
        path: '/gestione',
        element: (<Gestione />)
    },
    {
        path: '/gestioneTipologiaRegistri',
        element: (<GestioneTipologiaRegistri />)
    },
    {
        path: '/pac',
        element: (<PAC />)
    },
    {
        path: '/addPacDetail',
        element: (<AddPAC />)
    },
    {
        path: '/editPacDetail',
        element: (<EditPAC />)
    },
    {
        path: '/gestionePAC',
        element: (<GestionePAC />)
    },
    {
        path: '/addPac',
        element: (<GestionePACAdd />)
    },
    {
        path: '/editPac',
        element: (<GestionePACEdit />)
    },
    {
        path: '/gestionePrelievi',
        element: (<GestionePrelievi />)
    },
    {
        path: '/gestionePrelieviForAll',
        element: (<GestionePrelieviForAll />)
    },
    {
        path: '/complianceRequests',
        element: (<ComplianceRequests />)
    },
    {
        path: '/addComplianceRequest',
        element: (<AddComplianceRequest />)
    },
    {
        path: '/editComplianceRequest',
        element: (<EditRequestComplianceRequest />)
    },
    {
        path: '/periodoConversione',
        element: (<PeriodoConversione />)
    },
    {
        path: '/addPeriodoConversione',
        element: (<PeriodoConversioneAdd />)
    },
    {
        path: '/editPeriodoConversione',
        element: (<PeriodoConversioneEdit />)
    },
    {
        path: '/reinforcedControlMeasure',
        element: (<ReinforcedControlMeasure />)
    },
    {
        path: '/addReinforcedControlMeasure',
        element: (<AddReinforcedControlMeasure />)
    },
    {
        path: '/editReinforcedControlMeasure',
        element: (<EditReinforcedControlMeasure />)
    },
    {
        path: '/odc',
        element: (<OrganismiDiControllo />)
    },
    {
        path: '/provvedimentiCliente',
        element: (<CustomerMeasueres />)
    },
    {
        path: '/editCodexMeasure',
        element: (<EditCodexMeasure />)
    },
    {
        path: '/creaProvvedimentoAltroOdc',
        element: (<AddNewCodexMeasureOtherOdc />)
    },
    {
        path: '/addNewCodexMeasureStep1',
        element: (<AddNewCodexMeasureStep1 />)
    },
    {
        path: '/addNewCodexMeasureStep2',
        element: (<AddNewCodexMeasureStep2 />),
    },
    {
        path: '/editProvvedimentoAltroOdc',
        element: (<EditCodexMeasureOtherOdc />)
    },
    {
        path: '/measureRecipient',
        element: (<MeasureRecipient />)
    },
    {
        path: '/schedaCalcoloAdmin',
        element: (<SchedaCalcoloAdmin />)
    },
    {
        path: '/schedaCalcoloCustomer',
        element: (<SchedaCalcoloCustomer />)
    },
    {
        path: '/schedaCalcoloEdit',
        element: (<SchedaCalcoloAdminEdit />)
    },
    {
        path: '/sot',
        element: (<SOTAdmin />)
    },
    {
        path: '/notify',
        element: (<Notify />)
    },
    {
        path: '/notifyBioEdit',
        element: (<NotifyBioEdit />)
    },
    {
        path: '/notifyGlobalGapEdit',
        element: (<NotifyGlobalGapEdit />)
    },
    {
        path: '/incarichi',
        element: (<Incarichi />)
    },
    {
        path: '/inserisciIncarico',
        element: (<AddAssignment />)
    },
    {
        path: '/modificaIncarico',
        element: (<EditAssignment />)
    },
    {
        path: '/ivEdit',
        element: (<InspectionVisitEdit />)
    },
    {
        path: '/notificationAdmin',
        element: (<NotificationAdminPanel />)
    },
    {
        path: '/reportPersonaleContabile',
        element: (<ReportPersonaleContabileView />)
    },
    {
        path: '/personaleContabile',
        element: (<PersonaleContabileView />)
    },
    {
        path: '/proformaDetails',
        element: (<IncProformaDetails />)
    },
    {
        path: '/gestioneDemeter',
        element: (<GestioneDemeter />)
    },
    {
        path: '/gestioneBiosuisse',
        element: (<GestioneBiosuisse />)
    },
    {
        path: '/addCertificazioneBiosuisse',
        element: (<AddCertificazioneBiosuisse />)
    },
    {
        path: '/addCertificazioneDemeter',
        element: (<AddCertificazioneDemeter />)
    },
    {
        path: '/editDemeter',
        element: (<EditCertificazioneDemeter />)
    },
    {
        path: '/monitoraggioRid',
        element: (<MonitoraggioRID />)
    },
    {
        path: '/protocolloPre2015',
        element: (<OldProtocol />)
    },
    {
        path: '/monitoringFaseAvvio',
        element: (<MonitoringFaseAvvio />)
    },
    {
        path: '/listM024',
        element: (<M024 />)
    },
    {
        path: '/editM024',
        element: (<EditM024 />)
    },
    {
        path: '/dettaglioPersonaleContabile',
        element: (<PcDetailsInc />)
    },
])

export default adminRouter;
